import * as Yup from 'yup';
import { IUserCadasterRequiredForm } from '~/models/User';

export const UserSchema: Yup.SchemaOf<IUserCadasterRequiredForm> = Yup.object().shape(
  {
    image_url: Yup.string(),
    public_name: Yup.string(),
    name: Yup.string().required('Nome necessário.'),
    cpf: Yup.string().required('CPF necessário.'),
    cref: Yup.string().required('Registro Profissional necessário.'),
    birth_date: Yup.date().required('Data de nacismento é necessária.'),
    email: Yup.string().email('E-mail inválido.').required('E-mail necessário'),
    cellphone: Yup.string().required('Telefone necessário'),
    address_zip_code: Yup.string().required('CEP necessário.'),
    address_street: Yup.string().required('Endereço necessário'),
    address_number: Yup.number()
      .typeError('Número do endereço necessário.')
      .integer('Número do endereço deve ser um inteiro.')
      .positive('Número do endereço deve ser positivo.')
      .required('Número do endereço necessário.'),
    address_complement: Yup.string(),
    address_city: Yup.string().required('Cidade necessária'),
    address_state: Yup.string().required('Estado necessário'),
    address_country: Yup.string(),
  },
);
